import React from 'react';

import KpiDesktop from '../../../../components/kpiDesktop/KpiDesktop';
import { ReactComponent as Flecha } from '../../../../assets/svg/Flecha.svg';
import { ReactComponent as Fase1 } from '../../../../assets/svg/Fase1.svg';
import { ReactComponent as Fase2 } from '../../../../assets/svg/Fase2.svg';
import { ReactComponent as Fase3 } from '../../../../assets/svg/Fase3.svg';

export default function HomeInterno() {
    return (
        <>
            <div className='home-interno-container'>
                <div className='home-interno-banner'>   
                    <div className='home-interno-sistema'>
                        <div className='home-interno-sistema-titulo'>
                            Soporte Nutricional y Cuidado Domiciliario.<br />
                            Prestaciones modulares o por prácticas.
                        </div>
                    </div>
                </div>

                <div className='home-interno-secciones'>
                    <div className='home-interno-seccion'>
                        <div className='home-interno-seccion-titulo'>
                            Servicios Nutrihome
                        </div>
                        <div className='home-interno-seccion-descripcion'>
                            Descargá el vademécum completo.
                        </div>
                        <a href="https://www.nutrihome.com.ar/pdf/vademecum.pdf" color="#2D72B4" underline="none" title="Descargar Vademecum de Servicios Nutrihome" target="_blank">
                            <div className='home-interno-seccion-link'>
                                Descargar
                                <Flecha />                                
                            </div>
                        </a>                                                        
                    </div>
                    <div className='home-interno-seccion'>
                        <div className='home-interno-seccion-titulo'>
                            Nutrición enteral
                        </div>
                        <div className='home-interno-seccion-descripcion'>
                            Suplementos Nutricionales Orales. Próximamente descargá el vademécum completo.
                        </div>
                        {/* <Link href="https://www.nutrihome.com.ar/wp-content/uploads/2020/05/vademecum_2020.pdf" color="#2D72B4" underline="none" title="Descargar Vademecum de Servicios Nutrihome" target="_blank"> */}
                            <div className='home-interno-seccion-link'>
                                Próximamente
                                <Flecha /> 
                            </div>
                        {/* </Link>                 */}
                    </div>
                    <div className='home-interno-seccion'>
                        <div className='home-interno-seccion-titulo'>
                            Never events
                        </div>
                        <div className='home-interno-seccion-descripcion'>
                            Incidentes que no deben ocurrir.
                        </div>
                        <a href="#dv-events" color="#2D72B4" underline="none" title="Ir a la sección Never events">
                            <div className='home-interno-seccion-link'>
                                Leer más
                                <Flecha /> 
                            </div>
                        </a>                 
                    </div>
                    <div className='home-interno-seccion'>
                        <div className='home-interno-seccion-titulo'>
                            Nuestros valores
                        </div>
                        <div className='home-interno-seccion-descripcion'>
                            Cultura Corporativa.
                        </div>
                        <a href="#dv-valores" color="#2D72B4" underline="none" title="Ir a la sección Nuestros valores">
                            <div className='home-interno-seccion-link'>
                                Leer más
                                <Flecha /> 
                            </div>
                        </a>                
                    </div>
                </div>

                <div className='home-interno-modulos'>
                    <div className='home-interno-modulos-titulo'>
                        Incorporamos la teleconsulta en los siguientes módulos:
                    </div>                    
                    <div className='home-interno-modulos-grilla'>
                        <div className='home-interno-modulos-column img-modulo-1'>
                            <div className='home-interno-modulo-texto'>
                                Alimentación parenteral
                            </div>
                        </div>
                        <div className='home-interno-modulos-column img-modulo-2'>
                            <div className='home-interno-modulo-texto'>
                                Alimentación enteral
                            </div>
                        </div>

                        <div className='home-interno-modulos-column img-modulo-3'>
                            <div className='home-interno-modulo-texto'>
                                Alimentación oral / cetoanálogos
                            </div>
                        </div>
                    </div>
                </div>

                <div className='home-interno-fases'>
                    <div className='home-interno-fases-titulo'>
                        Cada módulo tendrá 3 fases:
                    </div>
                    <div className='home-interno-fases-grilla'>
                        <div className='home-interno-fases-column'>
                            <Fase1 />                            
                            <div className='home-interno-fase-numero'>
                                Fase 1
                            </div>
                            <div className='home-interno-fase-nombre'>
                                Inicio
                            </div>
                            <div className='home-interno-fase-texto'>
                                Adecuación del paciente al tratamiento.
                                Capacitación paciente /familiar.
                                <br />
                                <strong>Duración 3 meses.</strong>
                            </div>
                        </div>
                        <div className='home-interno-fases-column'>
                            <Fase2 />
                            <div className='home-interno-fase-numero'>
                                Fase 2
                            </div>
                            <div className='home-interno-fase-nombre'>
                                Mixta
                            </div>
                            <div className='home-interno-fase-texto'>
                                Evolución por teleconsulta que alterna visita
                                presencial de seguimiento
                                <br />
                                <strong>Duración 3 meses.</strong>
                            </div>
                        </div>
                        <div className='home-interno-fases-column'>
                            <Fase3 />
                            <div className='home-interno-fase-numero'>
                                Fase 3
                            </div>
                            <div className='home-interno-fase-nombre'>
                                Autocuidado
                            </div>
                            <div className='home-interno-fase-texto'>
                                Evolución por teleconsulta que alterna visita
                                presencial de seguimiento
                                <br />
                                <strong>Duración 3 meses.</strong>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='home-interno-valores-grilla'>
                    <div id="dv-valores" className='home-interno-valores-column home-interno-celeste'>
                        <div className='home-interno-valores-bloque'>
                            <div className='home-interno-valores-titulo'>
                                Nuestros valores
                            </div>
                            <div className='home-interno-valores-texto'>
                                Nuestros valores forman parte de nuestra cultura corporativa:
                                Enfoque al cliente, Calidad, Integridad, Colaboración, Creatividad, Pasión y Compromiso.
                                <br /><br />
                                El éxito de Nutrihome depende de cada uno de nosotros.
                                <br /><br />
                                Vivir nuestros valores es un requisito previo para diferenciarnos de la competencia y hacer realidad nuestra visión.
                            </div>
                        </div>                                                        
                        <div className='home-interno-valores-img'></div>
                    </div>
                    <div id="dv-events" className='home-interno-valores-column home-interno-gris'>
                        <div className='home-interno-valores-bloque'>
                            <div className='home-interno-valores-titulo'>
                                Never events
                            </div>
                            <div className='home-interno-valores-texto'>
                                1.- Prestar un servicio sin tener el consentimiento informado firmado.
                                <br /><br />
                                2.- Prestar servicio sin tener la capacitación del paciente o familiar firmada.
                                <br /><br />
                                3.- No tener una historia clínica documentada apropiadamente.
                                <br /><br />
                                4.- Comunicaciones a terceros sin autorización sobre rechazos de pacientes y suspensiones por falta de cobertura o negativa del paciente.
                                <br /><br />
                                5.- Colocar / recolocar una sonda sin hacer control por placa radiográfica o medición de pH.
                                <br /><br />
                                6.- No cumplir con el módulo pactado.
                                <br /><br />
                                7.- Falsificación de un registro.
                                <br /><br />
                                8.- Infundir medicación sin autorización de médico de seguimiento y sin revisar si no es alérgico al mismo.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <KpiDesktop />
        </>
    )
};
